module.exports = __webpack_public_path__ + "static/media/based.9bed8bdf.svg";